import { useQuery } from "react-query";
import { getDashboard } from "../services/supplier";

export const useGetDashboard = () => useQuery("dashboard", getDashboard);
